<template lang="">
	<div>
    <button @click="closeForm">
      <img style="width: 40px" src="../../../../static/images/close-grey.svg" />
    </button>
    <ValidationObserver v-slot="{ invalid }">
      <div>
        <v-card class="mt-8 mx-8">
          <div width="550" class="d-flex flex-column px-8 py-8">
            <div class="d-flex flex-column mr-8" >
            <ValidationProvider
              class="form-group"
              rules="required"
              v-slot="{ errors }"
            >
              <label class="font-weight-black">Produto</label>
              <input
                v-model="item.product_name"
                type="text"
                class="mt-3 b inputCopy"
                required
                name="nome do produto"
              >
              <span class="input-error">
                {{ errors[0] }} 
              </span>
            </ValidationProvider>
            </div>
            <div class="d-flex flex-row align-center mt-7">
              <label class="font-weight-black mr-2">Status</label>
              <v-switch
                v-model="item.product_is_active"
                color="var(--blue)"
                inset
                class="mt-3"
              ></v-switch>
            </div>
          </div>
        </v-card>
        <v-btn
          @click="handleSubmit"
          class="mt-4 ml-8"
          height="62"
          width="95"
          color="var(--red)"
          :disabled="invalid"
        >
          Enviar
        </v-btn>
      </div>
    </ValidationObserver>

    <div class="d-flex justify-center">
      <v-snackbar 
        v-model="openError"
        :timeout="timeout"
        color="var(--red)"
        top
      >
        <span style="color: var(--white)">{{ errorMessage }}</span>
      </v-snackbar>
    </div>
	</div>
</template>
<script>
// Lib
import { mapActions, mapState, mapMutations } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

import VueCookies from 'vue-cookies'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
	data () {
		return {
      disabled: true,
      status: null,
      notification: false,
      openError: false,
      timeout: 3000,
      errorMessage: ''
		}
  },
  created () {
  },
  computed: {
    ...mapState('Product', {
      item: 'productToEdit',
      loading: 'loading',
    })
  },
  methods: {
    ...mapActions('Product', [
      'postProduct',
      'updateProduct',
      'getProducts',
      'disableProduct'
    ]),
    ...mapMutations('Product', {
      unsetProductToEdit: 'UNSET_PRODUCT_TO_EDIT',
      setLoading: 'SET_LOADING'
    }),
    ...mapMutations('Shared', {
      setToaster: 'SET_TOASTER'
    }),
    validate () {
      if (this.checkProduct() && this.checkStatus()) {
        this.disabled = false
      }
    },
    checkProduct () {
      return this.item.product_name.length > 0
    },
    checkStatus () {
      return this.item.product_is_active !== null && this.item.product_is_active !== undefined
    },
    async handleSubmit () {
      this.setLoading(true)
      this.disabled = true
      const token = VueCookies.get('jwt-login')
      await this.handleSendProductInfo(token)
      await this.getProducts({token: token})
      this.setLoading(false)
    },
    async handleSendProductInfo(token) {
      if (this.item.product_id) {
        await this.handleUpdate(token)
      } else {
        await this.handlePost(token)
      }
    },
    toaster(message, color, visible) {
      this.setToaster({
        message,
        color,
        visible
      })
    },
    async handlePost(token) {
      try {
        const response = await this.postProduct([
          {
            product_name: this.item.product_name
          },
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Produto cadastrado com sucesso',
            'var(--green)',
            true
          )
          this.closeForm()
        }
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    async handleUpdate(token) {
      await this.updateProductData(token)
      if (!JSON.parse(this.item.product_is_active)) {
        await this.handleDisableProduct(token)
      }
    },
    async handleDisableProduct(token) {
      try {
        const response = this.disableProduct([
          this.item,
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Produto atualizado com sucesso',
            'var(--green)',
            true
          )
          this.closeModal()
          window.scrollTo(0, 0)
        }
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    async updateProductData (token) {
      try {
        const response = await this.updateProduct([
          {
            ...this.item,
            product_name: this.item.product_name,
            product_is_active: JSON.parse(this.item.product_is_active)
          },
          token
        ])
        if (response.status >= 400) {
          throw new Error(response.data.message)
        } else {
          this.toaster(
            'Produto atualizado com sucesso',
            'var(--green)',
            true
          )
          this.closeModal()
          window.scrollTo(0, 0)
        }
      } catch (error) {
        this.openError = true
        this.errorMessage = error.message
      }
    },
    closeForm () {
      this.unsetProductToEdit()
      this.$emit('close')
    },
    closeModal () {
      this.$emit('close')
    }
  },
  watch: {
    'item.product_name' () {
      this.item.product_name === null ? this.disabled = false : this.disabled = true
      this.validate()
    },
  }
}
</script>
<style lang="scss" scoped>
	.inputCopy {
    border: 2px solid var(--grey-day-030);
    border-radius: 4px;
    width: 492px; 
    height: 48px;
    padding: 15px;
    background: transparent;
    font-family: var(--dm-sans-regular);
    color: var(--grey);
  }
  .v-overlay__scrim {
    height: 200%
  }
  .notification {
    background: var(--red);
    width: 90%;
    margin-left: 5%;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
    border-radius: 4px;
    color: var(--white);
    transition: 2s;
  }
</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/ProductForm.vue